export const MAX_DEMONSTRATION_WIDTH = 924;
export const MAX_DEMONSTRATION_HEIGHT = Math.round((MAX_DEMONSTRATION_WIDTH / 16) * 9);
